(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball/assets/javascripts/ball-triss.js') >= 0) return;  svs.modules.push('/components/tur/ball/assets/javascripts/ball-triss.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.triss = svs.tur.ball.triss || {};
class BallTriss extends svs.tur.ball.Default {
  constructor(_ref) {
    let {
      number
    } = _ref;
    super({
      number,
      min: 1,
      max: 99
    });
    this.log = new svs.core.log.Logger('ball:triss');
  }
  createDomElements() {
    var _svs$ticketgames$game;
    this.$inner = this.createElement('inner');
    const imgUrl = (_svs$ticketgames$game = svs.ticketgames.gameHandler.games.find(g => g.open)) === null || _svs$ticketgames$game === void 0 || (_svs$ticketgames$game = _svs$ticketgames$game.skins[0]) === null || _svs$ticketgames$game === void 0 ? void 0 : _svs$ticketgames$game.url;

    this.$image = this.createElement('image', 'img');
    this.$image.src = imgUrl || "".concat(svs.core.config.data.svsconfig.cdn, "/images/tur/ball/triss").concat(this.number, ".png");
    this.$image.style.height = '100%';
    gsap.set(this.$image, {
      rotation: 13
    });
    this.$inner.appendChild(this.$image);
    this.$el.appendChild(this.$inner);
  }
  huxflux() {
    const tl = gsap.timeline();
    tl.fromTo(this.$image, {
      scale: 1,
      rotation: 13
    }, {
      duration: 0.3,
      rotation: 720,
      scale: 1.3
    });
    tl.to(this.$image, {
      duration: 0.3,
      rotation: 733,
      scale: 1,
      ease: 'back.out'
    });
    return tl;
  }
  prepare() {
    this._huxfluxToNumber = 0;
  }
  classNames() {
    return ['ball-triss'];
  }
}
svs.tur.ball.Triss = BallTriss;

 })(window);